"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuestionIcon = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const free_regular_svg_icons_1 = require("@fortawesome/free-regular-svg-icons");
const design_system_1 = require("@hashintel/design-system");
const material_1 = require("@mui/material");
const StyledQuestionIcon = (0, material_1.styled)((props) => ((0, jsx_runtime_1.jsx)(design_system_1.FontAwesomeIcon, { ...props, icon: free_regular_svg_icons_1.faQuestionCircle })))(({ theme }) => theme.unstable_sx({
    color: theme.palette.gray[40],
}));
const QuestionIcon = ({ tooltip, ...props }) => {
    return ((0, jsx_runtime_1.jsx)(material_1.Tooltip, { title: tooltip, placement: "top", PopperProps: {
            modifiers: [
                {
                    name: "offset",
                    options: {
                        offset: [0, 8],
                    },
                },
            ],
        }, children: (0, jsx_runtime_1.jsx)(material_1.Box, { display: "inline", ...props, children: (0, jsx_runtime_1.jsx)(StyledQuestionIcon, {}) }) }));
};
exports.QuestionIcon = QuestionIcon;
